
import { ReactNode } from "react";

interface HeaderSectionProps {
  children?: ReactNode;
}

export const HeaderSection = ({ children }: HeaderSectionProps) => {
  return (
    <div className="text-center space-y-6">
      <img 
        src="/lovable-uploads/139c637a-b7d5-4be9-b11c-cb9336b22a10.png" 
        alt="Market Validator" 
        className="h-24 mx-auto"
      />
      <div className="space-y-4">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-brand-primary via-brand-secondary to-brand-dark bg-clip-text text-transparent">
          Free Market Validation and Analysis Tool
        </h1>
        <p className="text-brand-dark max-w-4xl mx-auto text-lg">
          Calculate your Total Addressable Market (TAM), Serviceable Available Market (SAM), and Serviceable Obtainable Market (SOM) and get a report on the sector that is unique to you.
        </p>
      </div>
    </div>
  );
};
